import {
  OCRRequestDataTypes, OCRResponseDataTypes, StaffRequestType, StaffResponseType
} from './types';

import axiosInstance from 'services/common/instance';

export const getAllStaffService = async (
  params?: BaseFilterParams,
): Promise<APIPaginationResponse<Array<StaffResponseType>>> => {
  const res = await axiosInstance.get('staffs', { params });
  return res.data;
};

export const getStaffService = async (
  id: number,
): Promise<StaffResponseType> => {
  const res = await axiosInstance.get(`staffs/${id}`);
  return res.data.data;
};

export const deleteStaffService = async (
  ids: number[],
): Promise<void> => {
  await axiosInstance.delete('staffs', { data: { ids } });
};

export const createStaffService = async (
  params: any,
): Promise<void> => {
  await axiosInstance.post('staffs', params);
};

export const updateStaffService = async (
  params: { id: number, data: StaffRequestType },
): Promise<void> => {
  await axiosInstance.put(`staffs/${params.id}`, params.data);
};

export const ocrStaffInfoService = async (data: OCRRequestDataTypes):
  Promise<OCRResponseDataTypes> => {
  const res = await axiosInstance.post('staffs/ocr/get-data', data);
  return res.data;
};
